import ApolloIgnoredClientEditItem from '../../../Domain/ApolloIgnoredClientEditItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ApolloIgnoredClientService from '../../../Services/ApolloIgnoredClientService';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';

export default class ApolloIgnoredClientEditWindowDescription {
  static entityName = 'Ignored Client';
  static itemType = ApolloIgnoredClientEditItem;

  // The backend rejects on a duplicate (add) or a missing id (remove). Map that
  // rejection to a resolved { errorMessage } so the wizard shows a friendly toast
  // (its error branch) and stays open, instead of the generic GEWBF191 code.
  static serviceFunction = (edited) =>
    ApolloIgnoredClientService.AddNewApolloIgnoredClient(edited).catch(() => ({
      errorMessage:
        edited.type === CrudTypesEnum.Create
          ? 'This Client Id is already in the Apollo Ignored Clients list.'
          : 'This Client Id is not in the Apollo Ignored Clients list.',
    }));

  static messageOnSuccess = (edited) =>
    edited.type === CrudTypesEnum.Create
      ? 'Client added to the Apollo Ignored Clients list.'
      : 'Client removed from the Apollo Ignored Clients list.';

  static getActionOptions() {
    return [
      { label: 'Add to Ignored List', value: CrudTypesEnum.Create, disabled: false },
      { label: 'Remove from Ignored List', value: CrudTypesEnum.Delete, disabled: false },
    ];
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'Ignored Client',
      fields: [
        {
          fieldName: 'type',
          label: 'Action',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: () => ApolloIgnoredClientEditWindowDescription.getActionOptions(),
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'clientId',
          label: 'Apollo Client Id',
          className: 'col-12',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
      ],
    },
  ];
}
